import React from 'react';
import { Col } from 'react-bootstrap';
import {
  Card, CardBody, CardTitleWrap, CardTitle,
} from '@/shared/components/Card';
import toast from 'react-hot-toast';
import PropTypes from 'prop-types';
import { Button } from '../../../shared/components/Button';
import { AuthContext } from '../../../context/AuthContext';

const TemplateForm = ({ setTemplateRefresh }) => {
  const [loading, setLoading] = React.useState(false);
  const { apiGlobal } = React.useContext(AuthContext);
  const [varCount, setVarCount] = React.useState(0);
  const [templateContent, setTemplateContent] = React.useState('');

  // Function to count how many {{n}} variables exist in the string
  const countVariables = (content) => {
    const regex = /\{\{(\d+)\}\}/g;
    const matches = [...content.matchAll(regex)];
    // Get max number found or just count of variables found
    const numbers = matches.map(match => parseInt(match[1], 10));
    return numbers.length > 0 ? Math.max(...numbers) : 0;
  };

  const handleOnClickVariable = () => {
    // Next variable number is varCount + 1
    const nextVarNumber = varCount + 1;
    const newVariable = `{{${nextVarNumber}}}`;
    const newTemplateContent = templateContent + newVariable;

    setTemplateContent(newTemplateContent);
    setVarCount(nextVarNumber);
  };

  const handleTemplateContentChange = (e) => {
    const content = e.target.value;
    setTemplateContent(content);

    // Update varCount based on content
    const count = countVariables(content);
    setVarCount(count);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    const templateName = document.getElementById('template-name').value;

    if (!templateName || !templateContent) {
      toast.error('Please fill in all fields');
      setLoading(false);
      return;
    }

    const formData = new FormData();
    formData.append('name', templateName);
    formData.append('message', templateContent);

    try {
      const url = await fetch(`${apiGlobal}template_master_add.php`, {
        method: 'post',
        body: formData,
      });
      const response = await url.json();
      if (response.status && response.message === 'Template added successfully.') {
        document.getElementById('template-name').value = '';
        setTemplateContent('');
        setVarCount(0);
        setTemplateRefresh(prev => !prev);
        toast.success('Template added successfully');
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error('Error adding template:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Col md={12}>
        <Card>
          <CardBody>
            <CardTitleWrap>
              <CardTitle>Add Whatsapp Template</CardTitle>
            </CardTitleWrap>
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label htmlFor="template-name" className="form-label">Template Name</label>
                <input
                  type="text"
                  className="form-control"
                  id="template-name"
                  placeholder="Enter template name"
                  required
                />
              </div>
              <div className="mb-3">
                <label htmlFor="template-content" className="form-label">Template Content</label>
                <textarea
                  className="form-control"
                  id="template-content"
                  rows="3"
                  placeholder="Enter template content"
                  required
                  value={templateContent}
                  onChange={handleTemplateContentChange}
                />
              </div>
              <Button
                variant="warning"
                type="button"
                className="btn btn-warning"
                onClick={handleOnClickVariable}
              >
                Add Variable
              </Button>
              <Button
                variant="primary"
                type="submit"
                className="btn btn-primary"
                disabled={loading}
              >
                Add template
              </Button>
            </form>
          </CardBody>
        </Card>
      </Col>
    </div>
  );
};

TemplateForm.propTypes = {
  setTemplateRefresh: PropTypes.func.isRequired,
};

export default TemplateForm;
